import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGetDashBoardReviewsQuery } from "../../api/allReviewsAPI";
import { useDispatch, useSelector } from "react-redux";
import { setDashBoardReviewData } from "../../store/reducers/dashboardReviewsSlice";
import {
  FiClipboard,
  FiCalendar,
  FiRepeat,
  FiFileText,
} from "react-icons/fi";
import TileShell from "../DashboardTiles/TileShell";

const ReviewCard = ({ className = "" }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data: allReviewData, isSuccess } = useGetDashBoardReviewsQuery(
    {},
    { refetchOnMountOrArgChange: true }
  );
  const dashBoardReviewData = useSelector((state) => state.dashBoardReview);
  const handleArrowClick = () => {
    navigate("/allReview");
  };

  const rows = [
    {
      key: "pendingtimesheets",
      label: "Time Sheets",
      icon: FiClipboard,
      active: Boolean(isSuccess && dashBoardReviewData?.pendingtimesheets?.[0]),
    },
    {
      key: "pendingleaves",
      label: "Pending Leaves",
      icon: FiCalendar,
      active: Boolean(isSuccess && dashBoardReviewData?.pendingleaves?.[0]),
    },
    {
      key: "regularizations",
      label: "Regularization",
      icon: FiRepeat,
      active: Boolean(isSuccess && dashBoardReviewData?.regularizations?.[0]),
    },
    {
      key: "statusReports",
      label: "Status Reports",
      icon: FiFileText,
      active: Boolean(isSuccess && dashBoardReviewData?.statusReports?.[0]),
    },
  ];

  const pending = rows.filter((row) => row.active);

  useEffect(() => {
    if (isSuccess) {
      dispatch(setDashBoardReviewData(allReviewData.data));
    }
  }, [allReviewData, isSuccess]);

  return (
    <TileShell
      icon={FiClipboard}
      title="Review"
      actionLabel="View all"
      onAction={handleArrowClick}
      className={className}
      bodyClassName="flex flex-col"
    >
      <div className="flex items-baseline gap-2.5">
        <span className="text-5xl font-extrabold tracking-tight text-gray-900">
          {pending.length}
        </span>
        <span className="text-sm font-medium text-gray-500">
          {pending.length === 1 ? "thing to review" : "things to review"}
        </span>
      </div>

      <div className="mt-4 flex flex-col gap-2">
        {pending.length === 0 ? (
          <p className="text-sm text-gray-400">Nothing pending right now.</p>
        ) : (
          pending.map((row) => {
            const Icon = row.icon;
            return (
              <button
                key={row.key}
                type="button"
                onClick={handleArrowClick}
                className="flex w-full items-center gap-2.5 rounded-xl bg-blue-50 px-3 py-2.5 text-left transition hover:bg-blue-100"
              >
                <Icon className="flex-none text-blue-600" size={16} />
                <span className="min-w-0 flex-1 truncate text-sm font-semibold text-gray-700">
                  {row.label}
                </span>
              </button>
            );
          })
        )}
      </div>
    </TileShell>
  );
};

export default ReviewCard;
